import { routes } from "./routes.module";

const routesData = {
  defaultRoutes: [
    routes.home,
    routes.notFound,
    routes.userProfile,
    routes.myProfile,
    routes.users,
    routes.projectDetailView,
    routes.demandDraft,
    routes.viewDemand,
    routes.registeredLands,
    routes.userDetails,
    routes.landOwnershipDetails,
    routes.implementingAgency,
    routes.marketWatch,
    routes.changePassword,
    routes.fundTransfer,
    routes.fundDashboard,
    routes.fundApplicationDetails,
    routes.archivedFundApplications,
    routes.costEstimateDetails,
    routes.progressDetails,
    routes.advanceWorkProgress,
    routes.progressDetailsReport,
    routes.divisionProgressDetailsReport,
    routes.monitoring,
    routes.monitoringDetails,
    routes.monitoringReport,
    routes.submittedMonitorings,
    routes.selected,
    routes.detailedProjectReport,
    routes.dprForm,
    routes.memorandum,
    routes.payment,
    routes.paymentManagement,
    routes.selectedLandDetails,
    routes.gcaView,
    routes.exports,
  ],

  authRoutes: [routes.signIn, routes.login, routes.forgetPassword],
  guestRoutes: [],
};

export default routesData;
